import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/models/user';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Ability } from 'src/app/models/ability';
import {NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UnityService } from 'src/app/services/unity.service';
import { Unity } from 'src/app/models/unity';
import { Supplier } from 'src/app/models/supplier';
import { SupplierService } from 'src/app/services/supplier.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  public users:User[] = [];
  public usersTemp:User[] = [];
  public abilities: Ability[] = [];
  public loading = false;
  public user:User = new User();
  public unities:Unity[] = [];
  public suppliers:Supplier[] = [];
  public name:String;
  public actEditUser:boolean = true;
  public actAddUser:boolean = true;
  public actDeleteUser:boolean = true;
  public actPermUser:boolean = true;
  public actChangeUserPassword:boolean = false;
  public randomString = Math.random().toString(36).slice(-10);
  public copy:boolean = false;
  public generate:boolean = false;
  public expand:boolean = false;
  filters = {
    user: 'user',
    normal:'user',
    tool_supplier: 'tool_supplier',
    travel_supplier: 'travel_supplier', 
  };
  //Pagination
  public page:number = 1;
  public pagination:number = 20;
  //Searching
  public find:string = '';
  //Tipo de Usuario
  public user_type = null;

  constructor( private userService:UserService, private permService:PermissionsService, private modalService: NgbModal, private utl:UtilitiesService, private authService:AuthService, private toastr: ToastrManager, private unityServive: UnityService, private supplierService: SupplierService) { }

  async ngOnInit() {
    await this.getUsers();
    this.actEditUser = this.authService.can("update-user");
    this.actDeleteUser = this.authService.can("destroy-user");
    this.actPermUser = this.authService.can("authorization");
    this.actAddUser = this.authService.can("store-user");
    this.actChangeUserPassword = this.authService.has('change-user-password');
    this.unities = await this.unityServive.getFilteredUnities(20);
    this.suppliers = await this.supplierService.getSuppliers();
  }

  async getUsers() {
    this.loading = true;
    this.users = await this.userService.getUsers();
    this.filter();
    this.loading = false;
  }

  filter(){
    this.utl.search(this.users, ['id', 'name', 'last_name', 'email'], this.find, 'id', users => this.usersTemp = users);
  }

  select(modal?, user?:User) {
    this.copy = false;
    this.generate = false;
    if(user) {
      this.user = user;
      this.user_type = this.getUserType(this.user);
      this.user.user_type = this.user_type;
    } else {
      this.user = new User();
      this.user_type = this.setUserTyope(this.filters.user);
      this.user.user_type = this.user_type;
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }
  
  selectSupplier(){
    var e = (document.getElementById("supplier")) as HTMLSelectElement;
    this.user.last_name = e.options[e.selectedIndex].text;
  }
  
  async updateUser() {
    try {
      this.loading = true;
      let user = await this.userService.putUser(this.user);
      this.find = '';
      await this.getUsers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El ' + this.user_type + ' se ha actualizado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async storeUser() {
    try {
      this.loading = true;
      this.user.user_type = this.user_type; 
      let user = await this.userService.postUser(this.user);
      this.find = '';
      await this.getUsers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El ' + this.user_type + ' se ha creado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML: true});
    }
  }

  async deleteUser() {
    try {
      this.loading = true;
      this.user.user_type = this.user_type;
      let user = await this.userService.deleteUser(this.user);
      this.find = '';
      await this.getUsers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El ' + this.user_type + ' se ha eliminado correctamente', '', {enableHTML: true});
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async getPermissions(user:User, modal) {
    this.select(modal, user);
    this.loading = true;
    let perm = await this.permService.loadPermissions(user);
    this.abilities = perm.all;
    this.loading = false;
  }

  async changeUserPasswords(){
    try{
      this.loading = true;
      let user = await this.userService.changeUserPasswords(this.user);
      this.find = '';
      await this.getUsers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('La contraseña del usuario se ha actualizado correctamente', '', {enableHTML: true});
      //Si Christian Gonzalez (quien solo el tiene el permiso de cambiar contraseñas) cambia su contraseña entonces se cierra su sesion y debe logearse con las nuevas credenciales
      if(this.authService.getActualUser().id == 66 && this.user.id == 66){
        this.authService.logout();
      }
    }catch(e){
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', {enableHTML: true});
    }
  }

  copyRandomString(inputElement){
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.copy=true;
    this.generate=false;
    this.toastr.successToastr('La contraseña "' + this.randomString + '" se copió correctamente', '', {enableHTML: true});
    this.randomString="";
  }

  generateRandomString(){
    this.randomString = Math.random().toString(36).slice(-10);
    this.generate = true;
    this.user.password=this.randomString;
    this.user.password_confirmation=this.randomString;
    this.toastr.successToastr('La contraseña se generó correctamente', '', {enableHTML: true});
  }

  clearUser(){
    this.user = new User();
    this.user_type = this.setUserTyope(this.filters.user);
  }

  setUserTyope(user_type){
    switch(user_type)
    {
      case 'user': return 'Usuario'; case 'travel_supplier': return 'Proveedor Viajes'; case 'tool_supplier': return 'Proveedor Refacciones'; default: return 'Usuario';
    }
  }

  getUserType(user: User){
    if(user.unity_id){
      return 'Proveedor Viajes';
    }

    if(user.supplier_id){
      return 'Proveedor Refacciones';
    }

    if(user.id){
      return 'Usuario';
    }
  }
}